<div class="main-content">
  <mat-card class="mat-card-top">
    <mat-card-title>
      <h1 class="card-title">Manage Agents</h1>
    </mat-card-title>
    <mat-card-content>
      <div [formGroup]="userForm">
        <h2><strong>Create a New Agent</strong></h2>
        <mat-card>
          <mat-card-content>
            <table class="form-responsive">
              <tr>
                <th></th>
                <th></th>
              </tr>
              <tr>
                <td>
                  <mat-form-field appearance="outline">
                    <mat-label>Display Name</mat-label>
                    <input matInput placeholder="Display Name" formControlName="displayName" required />
                    <mat-error *ngIf="userForm.get('displayName').invalid">
                      This field is required
                    </mat-error>
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="outline">
                    <mat-label>Email</mat-label>
                    <input matInput placeholder="Email" formControlName="email" required />
                    <mat-icon matSuffix>email</mat-icon>
                    <mat-error *ngIf="userForm.get('email').invalid">
                      Not a valid email address
                    </mat-error>
                  </mat-form-field>
                </td>
              </tr>
              <tr>
                <td>
                  <mat-form-field appearance="outline">
                    <mat-label>First Name</mat-label>
                    <input matInput placeholder="First Name" formControlName="firstName" required />
                    <mat-error *ngIf="userForm.get('firstName').invalid">
                      This field is required
                    </mat-error>
                  </mat-form-field>
                </td>
                <td>
                  <mat-form-field appearance="outline">
                    <mat-label>Last Name</mat-label>
                    <input matInput placeholder="Last Name" formControlName="lastName" />
                    <mat-error *ngIf="userForm.get('lastName').invalid">
                      This field is required
                    </mat-error>
                  </mat-form-field>
                </td>
              </tr>
              <tr>
                <td>
                  <mat-form-field appearance="outline">
                    <mat-label>Password</mat-label>
                    <input matInput placeholder="Password" formControlName="password" type="password" minlength="8"
                      maxlength="16" required (input)="onPasswordInput()" />
                    <mat-error *ngIf="userForm.controls['password'].hasError('required')">
                      This field is required
                    </mat-error>
                  </mat-form-field>
                </td>

                <td>
                  <mat-form-field appearance="outline">
                    <mat-label>Confirm Password</mat-label>
                    <input matInput placeholder="Confirm Password" formControlName="passwordconfirm" type="password"
                      minlength="8" maxlength="16" required (input)="onPasswordInput()" />
                    <mat-error
                      *ngIf="userForm.controls['passwordconfirm'].hasError('required') || userForm.get('passwordconfirm').value.length == 0">
                      This field is required
                    </mat-error>
                  </mat-form-field>
                </td>
              </tr>
              <tr>
                <td style="font-weight: normal;">
                  <b>Password Requirements</b><br />
                  <mat-icon class="green-icon"
                    *ngIf="userForm.get('password').value.length > 0 && !userForm.controls['password'].hasError('minlength')">
                    check_circle</mat-icon>
                  <mat-icon class="red-icon"
                    *ngIf="userForm.get('password').value.length > 0 && userForm.controls['password'].hasError('minlength')">
                    close</mat-icon>
                  Password must be 8 to 16 characters<br />

                  <mat-icon class="green-icon"
                    *ngIf="userForm.get('password').value.length > 0 && !userForm.controls['password'].hasError('lowercase')">
                    check_circle</mat-icon>
                  <mat-icon class="red-icon"
                    *ngIf="userForm.get('password').value.length > 0 && userForm.controls['password'].hasError('lowercase')">
                    close</mat-icon>
                  Include 1 or more lowercase character(s)<br />

                  <mat-icon class="green-icon"
                    *ngIf="userForm.get('password').value.length > 0 && !userForm.controls['password'].hasError('uppercase')">
                    check_circle</mat-icon>
                  <mat-icon class="red-icon"
                    *ngIf="userForm.get('password').value.length > 0 && userForm.controls['password'].hasError('uppercase')">
                    close</mat-icon>
                  Include 1 or more uppercase character(s)<br />

                  <mat-icon class="green-icon"
                    *ngIf="userForm.get('password').value.length > 0 && !userForm.controls['password'].hasError('digit')">
                    check_circle</mat-icon>
                  <mat-icon class="red-icon"
                    *ngIf="userForm.get('password').value.length > 0 && userForm.controls['password'].hasError('digit')">
                    close</mat-icon>
                  Include 1 or more digit(s)<br />

                  <mat-icon class="green-icon"
                    *ngIf="userForm.get('password').value.length > 0 && !userForm.controls['password'].hasError('symbol')">
                    check_circle</mat-icon>
                  <mat-icon class="red-icon"
                    *ngIf="userForm.get('password').value.length > 0 && userForm.controls['password'].hasError('symbol')">
                    close</mat-icon>
                  Include 1 or more symbol(s)<br />
                </td>
                <td *ngIf="userForm.get('passwordconfirm').value.length > 0">
                  <mat-icon class="green-icon" *ngIf="!userForm.controls['passwordconfirm'].invalid">check_circle<p
                      style="color: green; font-weight: bold;">Passwords match</p>
                  </mat-icon>
                  <mat-icon class="red-icon"
                    *ngIf="userForm.controls['passwordconfirm'].invalid && !userForm.controls['passwordconfirm'].hasError('required')">
                    close<p style="color: red; font-weight: bold;">Passwords do not match</p>
                  </mat-icon>
                </td>
              </tr>
            </table>

            <br />
            <button type="submit" mat-raised-button class="seneca-button red" color="primary" (click)="createUser()"
              [disabled]="userForm.invalid">
              Create Agent
            </button>
          </mat-card-content>
        </mat-card>
      </div>

      <br />

      <h2><strong>List of Current Users</strong></h2>
      <div class="alignToRight csv-exporter">
        <span>
          <a (click)="exportToCsv()">Export
            to XLSX
            <span>
              <img src="../../../assets/img/export-excel-48-3.png" />
            </span>
          </a>
        </span>
      </div>
      <br />
      <br />
      <mat-card>
        <mat-card-content class="form-responsive">
          <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="LastName">
              <th class="priority-1" mat-header-cell *matHeaderCellDef mat-sort-header><b>Last Name</b></th>
              <td class="priority-1" mat-cell *matCellDef="let element">
                {{element.LastName}}
              </td>
            </ng-container>
            <ng-container matColumnDef="FirstName">
              <th class="priority-2" mat-header-cell *matHeaderCellDef mat-sort-header><b>First Name</b></th>
              <td class="priority-2" mat-cell *matCellDef="let element">
                {{element.FirstName}}
              </td>
            </ng-container>
            <ng-container matColumnDef="EmailAddress">
              <th class="priority-3" mat-header-cell *matHeaderCellDef mat-sort-header><b>Email</b></th>
              <td class="priority-3" mat-cell *matCellDef="let element">
                {{element.EmailAddress}}
              </td>
            </ng-container>
            <ng-container matColumnDef="Role">
              <th class="priority-3" mat-header-cell *matHeaderCellDef mat-sort-header><b>Role</b></th>
              <td class="priority-3" mat-cell *matCellDef="let element">
                {{element.RoleName}}
              </td>
            </ng-container>

            <!-- <ng-container matColumnDef="deleteButton">
              <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
              <td mat-cell *matCellDef="let element">
                <button [disabled]="this.currentUser.email === element.EmailAddress" mat-raised-button color="primary"
                  (click)="deleteUser(element)">
                  <mat-icon class="deleteBtn">delete</mat-icon>
                </button>
              </td>
            </ng-container> -->

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"
              [ngClass]="{'highlight-row': this.currentUser.email === row.EmailAddress}"></tr>
          </table>
          <mat-paginator [pageSizeOptions]="[5, 10, 20, 50]" [pageSize]="5" showFirstLastButtons></mat-paginator>
          <mat-error *ngIf="userTableError">Error loading Current Users table, contact an administrator. Status code:
            {{userTableError.status}}</mat-error>
        </mat-card-content>
      </mat-card>
    </mat-card-content>
  </mat-card>
</div>